import axios from "axios"
import baseUrl from "./apiUrl";

export async function getVaccines_request(IdContacto, params = {}) {
  try {
    let url = `${baseUrl}/vaccines/${IdContacto}`;
    const queryString = new URLSearchParams(params).toString();
    url = `${url}?${queryString}`
    const response = await axios({
        url: url,
        method: "GET",
        headers:
        {
            'Accept': 'application/json',
            'Content-Type': 'application/json',

            'Authorization': 'Bearer ' + localStorage.getItem("token")
        }
    });
    return response.data.Respuesta;
  } catch (error) {
    throw new Error("Hubo un error al intentar obtener las vacunas.");
  }
};


